import React, {memo, useState, useCallback, useContext} from 'react';
import AutomationPoint from './AutomationPoint.js';
import {
    setAutomationGuidePoint,
    setAutomationPointDragging} from 'actions/index.js';
import { connect } from "react-redux";
import {AutomationContext} from './context.js';
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {
    addAutomationBreakpoint,
    removeAutomationBreakpoint,
    moveAutomationBreakpoint
} from 'operations/actions.js';
import {
    getYPositionFromValue,
    getXPositionFromStep,
    getStepFromXPosition,
    getValueFromYPosition
} from './position.js';

import AutomationTooltip from './AutomationTooltip.js';

const AutomationPoints = memo(({
    height,
    xScale,
    isDragging,
    selectedParameter,
    sequencerEngine,
    pointHasMoved,
    operationManager,
    automation,
    automations
}) => {
    return (
        <Layer
          pixelRatio={1}
        >
       </Layer>
    );
});

export default AutomationPoints;
